import md5 from "md5";
import { useAuth } from "../../provider/authprovider";
import {useLocation} from 'react-router-dom';
import React, {useEffect,useRef} from 'react';

const AppForm = ({ app_instance, setFormData, linkRef, isHidden }) => {
    const hasRun = useRef(false);
    let instance_id = app_instance.instanceId;
    const location = useLocation();
    const queryparms = new URLSearchParams(location.search);
    let tarquery =  queryparms.get('targetQuery');
    let tarSystem = queryparms.get('targetSystem');
    const { userDetails } = useAuth();

    function getCurrentDateFormated(){
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return mm + '/' + dd + '/' + yyyy;
      }

      useEffect(()=>{
        if(instance_id!== undefined && instance_id!==null && instance_id.toUpperCase().includes(tarSystem) && !hasRun.current){
            hasRun.current = true;
            createXml(""); 
    
        
        }
     },[]);

    const setForm = (e) => {
        e.preventDefault();
        createXml("_blank"); 
    }

    if (isHidden) {
        return <a href="#link" onClick={setForm} ref={linkRef} style={{ display: "none" }}>{app_instance.title}</a>
    }
    return <a href="#link" onClick={setForm} ref={linkRef}>{app_instance.title}</a>



    function createXml(newtab){
        const UserId = userDetails.userId;
        const UserType = "I";
        const SystemId = "BHD";
        let SysCred = UserId + app_instance.link.secret_text;
        if(app_instance.link.include_date){
          SysCred = SysCred + getCurrentDateFormated();
        }
        const hashedMessage =  md5(SysCred).toUpperCase();       
        const StayAliveURL = app_instance.link.stay_alive_url;
        let targetqueryparam  = (tarquery!== null && tarquery.length > 0) ?tarquery : app_instance.link.target_query ;
        let targetQuery = ""; 
        if (targetqueryparam !== undefined && targetqueryparam.length > 0) {
            targetQuery = '<TargetQuery>' + targetqueryparam + '</TargetQuery>'
        }
        const xml = `<?xml version="1.0" encoding="ISO-8859-1"?><AuthMsg><UserId>${UserId}</UserId><UserType>${UserType}</UserType><SystemId>${SystemId}</SystemId><SystemCredentials>${hashedMessage}</SystemCredentials>${targetQuery}<StayAliveURL>${StayAliveURL}</StayAliveURL></AuthMsg>`;
        setFormData({ url: app_instance.link.url, authMessage: xml, newTab: newtab  })
    }
}

export default AppForm;